import React, { useEffect } from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectId } from "redux/features/auth/authSlice"
import { fetchConsent } from "redux/features/consent/consentThunk"
import {
  selectConsentById,
  selectFetchStatus,
} from "redux/features/consent/consentSlice"
import LoadableEntity from "components/ui/LoadableEntity"
import { ConsentType } from "types"

export function withConsent<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithConsent = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const clientId = useAppSelector((state) => selectId(state))
    const consent = clientId
      ? useAppSelector(
          (state) => selectConsentById(state, clientId) as ConsentType,
        )
      : null

    const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

    const handleFetchConsent = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchConsent())
      }
    }

    useEffect(() => handleFetchConsent(), [])

    return (
      <LoadableEntity
        entity={consent}
        fetchStatus={fetchStatus}
        renderError={() => <></>}
      >
        {(consent) => (
          <WrappedComponent
            {...props}
            consent={consent}
            fetchStatus={fetchStatus}
            fetchConsent={handleFetchConsent}
          />
        )}
      </LoadableEntity>
    )
  }

  return WithConsent
}
